import { SkeletonList } from 'components/Skeleton/SkeletonList';
import AppContext from 'context';
import { TTruckerItem } from 'context/reducers/truckers.type';
import { useAppStates } from 'hooks/useAppStates';
import { useNavigate, useParams } from 'react-router-dom';

import React, { FC, useContext, useEffect } from 'react';

import { FuelTab, FuelTabContent, FuelTabItem } from '@frete.com/fuel-react';
import TruckerRefundableList from 'components/TruckerRefundableList';
import { TARIFF_URL, TARRIF_TAB } from 'context/reducers/tabs.type';
import { useRefundableFare } from 'hooks/useRefundableFare';
import { SuggestedTruckDrivers } from '../SuggestedTruckDrivers';

export const Listing: FC<{
  truckerListData: TTruckerItem[];
}> = ({ truckerListData }) => {
  const {
    state: {
      refundableFare: { dataRefundableFare },
      tabs: { activeTab },
    },
    dispatch,
  } = useContext(AppContext);
  const { activeTab: urlPath, freightId } = useParams();
  const navigate = useNavigate();
  const { fetchRefundableFare } = useRefundableFare();
  const { isLoadingPartial } = useAppStates();

  function handleClick(activeIndex: number) {
    dispatch({ type: 'tab_active_set', payload: activeIndex });

    if (activeIndex === TARRIF_TAB) {
      navigate(`/meus-fretes/${freightId}/motoristas/tarifa/`);
    }
  }

  const renderTabRefundableFare = urlPath === TARIFF_URL;

  useEffect(() => {
    if (urlPath === TARIFF_URL) {
      fetchRefundableFare();

      navigate(`/meus-fretes/${freightId}/motoristas/tarifa/`);
    }
  }, []);

  return (
    <>
      {isLoadingPartial ? (
        <SkeletonList selfPadding />
      ) : (
        <FuelTab divider activeTab={activeTab}>
          <FuelTabItem slot="tabs" onClick={() => handleClick(0)}>
            Sugeridos
          </FuelTabItem>

          {renderTabRefundableFare && (
            <FuelTabItem badgeContent={dataRefundableFare?.length} slot="tabs" onClick={() => handleClick(1)}>
              Pagaram a taxa
            </FuelTabItem>
          )}

          <FuelTabContent>
            <SuggestedTruckDrivers truckerListData={truckerListData} />
          </FuelTabContent>

          <FuelTabContent>{renderTabRefundableFare && <TruckerRefundableList />}</FuelTabContent>
        </FuelTab>
      )}
    </>
  );
};
